export default "__VITE_ASSET__DnC8McGd__"